import { z } from 'zod';

const isoDay = z
  .string()
  .trim()
  .min(1, 'Pick a date')
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Pick a valid date');

/** The export always needs an explicit, ordered range — mirrors the server's own schema. */
export const paymentExportRangeSchema = z
  .object({
    from: isoDay,
    to: isoDay,
    basis: z.enum(['raised', 'collected']),
  })
  .refine((value) => value.from <= value.to, {
    message: 'From date must be on or before To date',
    path: ['from'],
  });

export type PaymentExportRangeValues = z.infer<typeof paymentExportRangeSchema>;
